import React from 'react';
import './Large.styles.css';

export const Large: React.FC = () => {
    return (
      <div className="btn-loader-large"></div>
    );
};
